const validateParams = params => params.forEach(({ name, type, value }) => {
    const to = typeof value;
    if (to !== type) {
        throw new Error(`Invalid parameter "${name}" must be of type "${type}", but got "${to}"`);
    }
});

export default validateParams;
